if (!customElements.get('quick-view-modal')) {
  customElements.define(
    'quick-view-modal',
    class QuickViewModal extends DrawerComponent {
      constructor() {
        super();

        this._classes = {
          loaded: 'quick-view-loaded',
        };
        this.drawerBody = this.querySelector(this.selector);
      }

      get selector() {
        return '.quick-view__content';
      }

      get sourceSelector() {
        return '#MainProduct-quick-view__content';
      }

      get requiresBodyAppended() {
        return !(Shopify.designMode && this.closest('.section-group-overlay-quick-view'));
      }

      shouleBeShow() {
        const sectionId = this.getProductQuickViewSectionId();
        return typeof sectionId === 'string';
      }

      prepareToShow() {
        super.prepareToShow();
        this.quickview();
      }

      handleAfterShow() {
        super.handleAfterShow();
        document.dispatchEvent(
          new CustomEvent('quick-view:open', {
            detail: { productUrl: this.dataset.productUrl },
          })
        );
      }

      handleAfterHide() {
        super.handleAfterHide();
        const drawerContent = this.querySelector(this.selector);
        drawerContent.innerHTML = '';
        this.classList.remove(this._classes.loaded);
      }

      getProductQuickViewSectionId() {
        let sectionId = FoxTheme.QuickViewSectionId || false;

        if (!sectionId) {
          // Get section id from overlay groups.
          const productQuickView = document.querySelector('.section-group-overlay-quick-view');
          if (productQuickView) {
            sectionId = FoxTheme.utils.getSectionId(productQuickView);
          }

          // Cache for better performance.
          FoxTheme.QuickViewSectionId = sectionId;
        }

        return sectionId;
      }

      quickview() {
        const drawerContent = this.querySelector(this.selector);
        const sectionId = this.getProductQuickViewSectionId();
        const sectionUrl = `${this.dataset.productUrl.split('?')[0]}?section_id=${sectionId}`;
        fetch(sectionUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const productElement = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector(this.sourceSelector);

            // Reorder the buy-buttons in the DETACHED fragment before injecting it, so the
            // <quantity-input> connects only once. Moving it after injection would disconnect +
            // reconnect it, and the theme's quantity-input re-adds its +/- click handlers on
            // connect without removing the old ones (its AbortController signal is misplaced) —
            // which double-fired the stepper (1 → 3 → 5).
            const fragment = productElement.content.cloneNode(true);
            this.pinBuyButtons(fragment);
            this.setInnerHTML(drawerContent, fragment);
            FoxTheme.a11y.trapFocus(this, this.focusElement);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            setTimeout(() => {
              this.classList.add(this._classes.loaded);
            }, 300);

            document.dispatchEvent(
              new CustomEvent('quick-view:loaded', {
                detail: { productUrl: this.dataset.productUrl },
              })
            );
          })
          .catch((e) => {
            console.error(e);
          });
      }

      /**
       * Quick View only: move the quantity + Add to cart block to the end of the product info so CSS
       * can pin it to the bottom of the drawer as a sticky bar (the CTA is otherwise below the fold
       * on short screens). It stays INSIDE <product-info> so purchase-options.js still finds its
       * <subscription-selector> (scoped to the closest product-info) and Subscribe/One-time keeps
       * driving it. "View full details" then renders just above it, as a plain link under the refill.
       */
      pinBuyButtons(container) {
        const buyBlock = container.querySelector('.product__block--buy_buttons');
        if (!buyBlock) return;
        // Append to the info container (the flex column holding blocks/refill/view-details) so the
        // sticky bar sits at the bottom. Stays inside <product-info>, so purchase-options.js still
        // finds its <subscription-selector> (scoped to the closest product-info).
        const host =
          buyBlock.closest('.product__info-container') || buyBlock.closest('product-info') || container;
        host.appendChild(buyBlock);
      }

      setInnerHTML(element, innerHTML) {
        element.innerHTML = '';
        element.appendChild(innerHTML);
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      disconnectedCallback() {
        super.disconnectedCallback();
        this.handleAfterHide();
      }
    }
  );
}
